import { createActionsCreator } from '../actionCreatorsFactory'

const createAction = createActionsCreator('SAGAS/UI')

export const showSidebar = createAction('SHOW_SIDEBAR')
export const hideSidebar = createAction('HIDE_SIDEBAR')
export const setRowsOnPage = createAction('SET_ROWS_ON_PAGE')
export const setPageNumber = createAction('SET_PAGE_NUMBER')
